import { useState } from "react";
import { Phone, CircleCheck as CheckCircle2, ShieldCheck, Star, ArrowRight, Camera, Shield, CircleCheck } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
const HERO_IMG = {
  desktop: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/panel-hero-desktop.webp",
  tablet: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/panel-hero-desktop.webp",
  mobile: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/panel-hero-desktop.webp"
};
const NAVY = "#081438";
const GOLD = "#F5A623";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
export default function PanelHero() {
  return <section className="relative isolate overflow-hidden !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/06/repair-hero-desktop-1.webp)]" style={{
    background: NAVY,
    minHeight: "100vh",
    paddingTop: "120px",
    paddingBottom: "80px",
    fontFamily: FONT_BODY
  }}>
      {}
      <picture>
        <source media="(max-width: 640px)" srcSet={HERO_IMG.mobile} />
        <source media="(max-width: 1024px)" srcSet={HERO_IMG.tablet} />
        <img src={HERO_IMG.desktop} alt="" aria-hidden="true" loading="eager" decoding="async" style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        opacity: 0.5,
        zIndex: 0
      }} />
      </picture>

      <div style={{
      position: "absolute",
      inset: 0,
      background: `linear-gradient(135deg, ${NAVY} 0%, rgba(8,20,56,0.55) 50%, rgba(8,20,56,0.7) 100%)`,
      zIndex: 1
    }} />

      <div style={{
      position: "absolute",
      inset: 0,
      opacity: 0.04,
      mixBlendMode: "overlay",
      zIndex: 2,
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Cfilter id='n'%3E%3CfeTurbulence baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")",
      pointerEvents: "none"
    }} />

      <div style={{
      position: "absolute",
      top: 120,
      left: 0,
      width: 4,
      height: 80,
      background: GOLD,
      zIndex: 3
    }} />

      <div style={{
      position: "relative",
      zIndex: 4,
      maxWidth: 1280,
      margin: "0 auto",
      padding: "0 24px",
      display: "grid",
      gridTemplateColumns: "minmax(0, 1.1fr) minmax(0, 0.9fr)",
      gap: 56,
      alignItems: "center"
    }} className="panel-hero-grid">
        {}
        <div>
          <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 10,
          padding: "8px 16px",
          background: "rgba(245,166,35,0.1)",
          border: "1px solid rgba(245,166,35,0.3)",
          borderRadius: 100,
          marginBottom: 28
        }}>
            <Camera size={14} color={GOLD} strokeWidth={2.5} />
            <span style={{
            fontFamily: FONT_BODY,
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: GOLD
          }}>
              Panel Replacement Specialists · Sydney
            </span>
          </div>

          <h1 style={{
          fontFamily: FONT_HEAD,
          fontSize: "clamp(36px, 5.5vw, 64px)",
          fontWeight: 800,
          color: "#ffffff",
          lineHeight: 1.02,
          letterSpacing: "-0.025em",
          margin: "0 0 24px"
        }}>
            Dented Panel?{" "}
            <span style={{
            background: `linear-gradient(135deg, ${GOLD} 0%, #D4A63A 100%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            display: "inline-block",
            fontStyle: "italic"
          }}>
              Don't replace
            </span>
            <br />
            the whole door.
          </h1>

          <p style={{
          fontFamily: FONT_BODY,
          fontSize: "clamp(16px, 1.4vw, 19px)",
          color: "rgba(255,255,255,0.78)",
          lineHeight: 1.6,
          maxWidth: 560,
          margin: "0 0 36px"
        }}>
            Most damaged garage doors only need a single panel swap — not a full
            replacement. We stock 150+ panels at our Bass Hill workshop in every
            common colour and profile. Insurance-friendly quotes, same-day
            assessments.
          </p>

          <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 24,
          marginBottom: 40
        }}>
            {[{
            Icon: Star,
            text: "5.0  Google rated"
          }, {
            Icon: ShieldCheck,
            text: "Insurance quotes accepted"
          }, {
            Icon: CheckCircle2,
            text: "150+ panels in stock"
          }].map(({
            Icon,
            text
          }, i) => <div key={i} data-index={i} style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            color: "rgba(255,255,255,0.85)",
            fontSize: 14,
            fontWeight: 500,
            fontFamily: FONT_BODY
          }}>
                <Icon size={18} color={GOLD} strokeWidth={2} />
                {text}
              </div>)}
          </div>

          <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 14
        }}>
            <Link to="tel:0485000933" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "16px 28px",
            background: GOLD,
            color: NAVY,
            fontFamily: FONT_HEAD,
            fontSize: 16,
            fontWeight: 700,
            borderRadius: 12,
            textDecoration: "none",
            transition: "transform 0.2s, box-shadow 0.2s",
            boxShadow: "0 8px 24px rgba(245,166,35,0.3)"
          }} onMouseEnter={e => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 32px rgba(245,166,35,0.45)";
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 24px rgba(245,166,35,0.3)";
          }}>
              <Phone size={18} strokeWidth={2.5} />
              0485 000 933
            </Link>
            <Link to="#contact-us" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "16px 28px",
            background: "transparent",
            color: "#ffffff",
            fontFamily: FONT_HEAD,
            fontSize: 16,
            fontWeight: 600,
            borderRadius: 12,
            textDecoration: "none",
            border: "1px solid rgba(255,255,255,0.25)",
            transition: "background 0.2s, border-color 0.2s"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.background = "rgba(255,255,255,0.08)";
            (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.4)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.background = "transparent";
            (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.25)";
          }}>
              Get Free Quote
              <ArrowRight size={16} strokeWidth={2.5} />
            </Link>
          </div>
        </div>

        {}
        <FormProvider id="contact-us" formId="hero_quote_form" sectionName="GarageHero" className="bg-white backdrop-blur-sm border-[#F5A623]/40 p-6 md:p-8 rounded-lg shadow-2xl relative scroll-mt-28" defaultValues={{
        name: "",
        phone: "",
        suburb: "",
        service: ""
      }}>
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#F5A623] via-[#ffc142] to-[#F5A623] rounded-t-lg" />
          
          <div className="text-center mb-6">
            <h2 className="text-2xl md:text-3xl font-bold mb-2" style={{
            color: NAVY,
            fontFamily: FONT_HEAD
          }}>
              Get Your Free Quote
            </h2>
            <p className="text-sm font-medium opacity-80" style={{
            color: NAVY
          }}>
              Fast response · No obligation · No hidden fees
            </p>
          </div>

          <HeroQuoteForm />

          <div className="mt-6 pt-6 border-t flex items-center justify-between gap-3 flex-wrap" style={{
          borderColor: "rgba(245, 166, 35, 0.2)"
        }}>
            {[{
            Icon: Shield,
            text: "Licensed"
          }, {
            Icon: CircleCheck,
            text: "Insured"
          }, {
            Icon: Star,
            text: "5.0 Rated"
          }].map(({
            Icon,
            text
          }, i) => <div key={i} data-index={i} className="flex items-center gap-1.5">
                <Icon className="h-3.5 w-3.5" style={{
              color: GOLD
            }} />
                <span className="text-[11px] font-bold uppercase tracking-wider" style={{
              color: GOLD
            }}>
                  {text}
                </span>
              </div>)}
          </div>
        </FormProvider>
      </div>

      <style>{`
        @media (max-width: 960px) {
          .panel-hero-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
        }
      `}</style>
    </section>;
}
function HeroQuoteForm() {
  const {
    control,
    handleSubmit,
    isSubmitting,
    isSubmitted,
    successMessage,
    submitError
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-green-50 border border-green-200 rounded-lg text-center">
        <CheckCircle2 className="mx-auto h-12 w-12 text-green-500 mb-4" />
        <p className="text-green-800 font-semibold">{successMessage || "Thank you! We'll contact you shortly."}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-3">
      <FormField control={control} name="name" rules={{
      required: "Name is required"
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input placeholder="Your Name" {...field} className="bg-gray-50 border-gray-200 text-[#081438] focus:border-[#F5A623] focus:ring-[#F5A623] rounded-md" />
            </FormControl>
            <FormMessage />
          </FormItem>} />
      <FormField control={control} name="phone" rules={{
      required: "Phone is required"
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input type="tel" placeholder="Phone Number" {...field} className="bg-gray-50 border-gray-200 text-[#081438] focus:border-[#F5A623] focus:ring-[#F5A623] rounded-md" />
            </FormControl>
            <FormMessage />
          </FormItem>} />
      <FormField control={control} name="suburb" rules={{
      required: "Suburb is required"
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input placeholder="Suburb" {...field} className="bg-gray-50 border-gray-200 text-[#081438] focus:border-[#F5A623] focus:ring-[#F5A623] rounded-md" />
            </FormControl>
            <FormMessage />
          </FormItem>} />
      <FormField control={control} name="service" rules={{
      required: "Please select a service"
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <select {...field} className="w-full h-10 px-3 py-2 bg-gray-50 border border-gray-200 text-[#081438] focus:border-[#F5A623] focus:ring-[#F5A623] rounded-md text-sm outline-none">
                <option value="" disabled>Select Service</option>
                <option value="Panel Replacement">Panel Replacement</option>
                <option value="Dented Door Repair">Dented Door Repair</option>
                <option value="Insurance Quote">Insurance Quote</option>
                <option value="Other">Other</option>
              </select>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <p className="text-red-500 text-xs text-center">{submitError}</p>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-[#F5A623] hover:bg-[#D4A63A] text-[#081438] font-bold py-6 rounded-md shadow-lg transition-all hover:-translate-y-0.5">
        {isSubmitting ? "Sending..." : "Get Free Quote"}
        {!isSubmitting && <ArrowRight className="ml-2 h-5 w-5" />}
      </Button>
      
      <p className="text-[10px] text-center text-gray-400 mt-2">
        By submitting you agree to our terms of service.
      </p>
    </Form>;
}